import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-online-experience-location',
  templateUrl: './online-experience-location.component.html',
  styleUrls: ['./online-experience-location.component.css']
})
export class OnlineExperienceLocationComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  countries = [];
  cities = [];

  constructor(
    private sharedApi: SharedService
  ) { }

  ngOnInit() {
    this.sharedApi.getAllCountries().subscribe(response => {
      this.countries = response.data.countries;
    });
    this.experienceForm.controls.countryId.valueChanges.subscribe(newCountryId => {
      this.getCities(newCountryId);
    })
  }

  getCities(countryId) {
    if (countryId) {
      this.sharedApi.getAllCities(countryId).subscribe(response => {
        this.cities = response.data.cities;
      })
    } else {
      this.cities = [];
    }
  }

}
